/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStreamingBlockConfig
 */
export interface SurfaceStreamingBlockConfig {
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceStreamingBlockConfig
     */
    showChat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceStreamingBlockConfig
     */
    showViewerCount?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStreamingBlockConfig
     */
    layout?: SurfaceStreamingBlockConfigLayoutEnum;
    /**
     * 
     * @type {number}
     * @memberof SurfaceStreamingBlockConfig
     */
    maxStreams?: number;
}


/**
 * @export
 */
export const SurfaceStreamingBlockConfigLayoutEnum = {
    theater: 'theater',
    compact: 'compact',
    featured: 'featured'
} as const;
export type SurfaceStreamingBlockConfigLayoutEnum = typeof SurfaceStreamingBlockConfigLayoutEnum[keyof typeof SurfaceStreamingBlockConfigLayoutEnum];


/**
 * Check if a given object implements the SurfaceStreamingBlockConfig interface.
 */
export function instanceOfSurfaceStreamingBlockConfig(value: object): value is SurfaceStreamingBlockConfig {
    return true;
}

export function SurfaceStreamingBlockConfigFromJSON(json: any): SurfaceStreamingBlockConfig {
    return SurfaceStreamingBlockConfigFromJSONTyped(json, false);
}

export function SurfaceStreamingBlockConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStreamingBlockConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'showChat': json['showChat'] == null ? undefined : json['showChat'],
        'showViewerCount': json['showViewerCount'] == null ? undefined : json['showViewerCount'],
        'layout': json['layout'] == null ? undefined : json['layout'],
        'maxStreams': json['maxStreams'] == null ? undefined : json['maxStreams'],
    };
}

export function SurfaceStreamingBlockConfigToJSON(json: any): SurfaceStreamingBlockConfig {
    return SurfaceStreamingBlockConfigToJSONTyped(json, false);
}

export function SurfaceStreamingBlockConfigToJSONTyped(value?: SurfaceStreamingBlockConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'showChat': value['showChat'],
        'showViewerCount': value['showViewerCount'],
        'layout': value['layout'],
        'maxStreams': value['maxStreams'],
    };
}

